import React from 'react';
import { Link } from 'react-router-dom';
import SubLayout from '../../components/Layout/SubLayout'
import strings from '../../components/Language';
import "./profile.scss"

import ArrowForword from './../../assets/images/icons/arrow_forword.svg';

class SecurityCentreScreen extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			checked: false,
		}

	}

	render() {
		return (
			<SubLayout data={{ "title": strings.security_centre }}>
				<div className="profile-subpage">
					<div className='profile-panel'>
						<Link to="/change-password" className='profile-list-item'>
							<div className='profile-list-left'>
								<span>{strings.change_password}</span>
							</div>
							<div className='profile-list-right'>
								<img src={ArrowForword} alt="ArrowForword"></img>
							</div>
						</Link>
						<Link to="/transaction-password" className='profile-list-item'>
							<div className='profile-list-left'>
								<span>{strings.transaction_password}</span>
							</div>
							<div className='profile-list-right'>
								<img src={ArrowForword} alt="ArrowForword"></img>
							</div>
						</Link>
					</div>
				</div>
			</SubLayout >
		);
	}
}

export default SecurityCentreScreen;
